var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"pageSvg","width":_vm.canvasWidth,"height":_vm.canvasHeight,"viewBox":_vm.viewBox}},_vm._l((_vm.canvas),function(comp,index){return _c('video-comp',{key:comp.id,attrs:{"data":comp,"z":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }